import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import Immutable from 'immutable';

import config from 'config/global';
import dates from 'utils/dates';
import calendarUtils from 'utils/calendar';
import { dayInMilliseconds, range } from 'utils/utils';

import SearchUnitCustomControlCalendarDay from './SearchUnitCustomControlCalendarDay';

import './SearchUnitCustomControlCalendar.scss';

export default class SearchUnitCustomControlCalendar extends Component {
  static propTypes = {
    appState: PropTypes.object.isRequired,
    availability: PropTypes.object,
    dimensionsEntities: PropTypes.object,
    dimensionsResult: PropTypes.object,
    handleDayClick: PropTypes.func.isRequired,
    hideLegend: PropTypes.bool,
    isHotelOnly: PropTypes.bool,
    loadDayOfMonthData: PropTypes.func,
    monthViewDayStamp: PropTypes.number,
    params: PropTypes.object,
    parentRoute: PropTypes.string,
    selectedCalendarDayStamp: PropTypes.number,
    type: PropTypes.string,
  };

  static defaultProps = {
    appState: Immutable.Map(),
    availability: Immutable.List(),
    hideLegend: false,
    isHotelOnly: false,
  };

  state = {}

  componentDidMount() {
    const { loadDayOfMonthData, monthViewDayStamp } = this.props;

    if (loadDayOfMonthData) {
      loadDayOfMonthData(monthViewDayStamp);
    }
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  onMonthChange = (event) => {
    this.changeMonth(event.currentTarget.value);
  };

  getMonthsCollection(date = dates.utcDate()) {
    date.setDate(1);

    const monthsCollection = [];

    for (let i = 0; i < config.numberOfCalendarMonths; i++) {
      const timestamp = Date.UTC(date.getFullYear(), date.getMonth() + i, 1);
      const calDate = timestamp / dayInMilliseconds;
      const monthAndYearText = dates.format(timestamp, 'MMMM YYYY');

      monthsCollection.push({
        name: monthAndYearText,
        value: `${calDate}`,
      });
    }

    return monthsCollection;
  }

  monthCollection = this.getMonthsCollection()

  get currentMonthIndex() {
    return this.monthCollection.findIndex(element => this.firstOfMonthToViewDayStamp === element.value);
  }

  changeMonth(monthViewDayStamp) {
    const { loadDayOfMonthData } = this.props;
    if (loadDayOfMonthData) {
      loadDayOfMonthData(monthViewDayStamp);
    }
    this.setState({ monthViewDayStamp });
  }

  goToPreviousMonth = (event) => {
    event.preventDefault();
    this.changeMonth(this.monthCollection[this.currentMonthIndex - 1].value);
  }

  goToNextMonth = (event) => {
    event.preventDefault();
    this.changeMonth(this.monthCollection[this.currentMonthIndex + 1].value);
  }

  get isFirstMonth() {
    return this.currentMonthIndex === 0;
  }

  get isLastMonth() {
    return this.currentMonthIndex === this.monthCollection.length - 1;
  }

  isDayUnavailable = (i) => {
    const { availability, isHotelOnly, type } = this.props;
    // TODO: if isHotelOnly is true, the day on the calendar will always be available
    // TODO: once the dayOfMonth api supports HotelOnly, this 'isHotelOnly returns false' logic can be removed
    return type === 'search-unit' && !isHotelOnly ? !availability.get(i) : false;
  }

  render() {
    const {
      appState,
      handleDayClick,
      hideLegend,
      monthViewDayStamp,
      selectedCalendarDayStamp,
    } = this.props;

    const nowTimestamp = dates.utcDate(Date.now());
    const nowDaystamp = Math.floor(nowTimestamp / dayInMilliseconds);
    const selectedTimestamp = selectedCalendarDayStamp * dayInMilliseconds;
    const monthViewTimestamp = (this.state.monthViewDayStamp || monthViewDayStamp || nowDaystamp) * dayInMilliseconds;

    const timestampToView = monthViewTimestamp || selectedTimestamp || nowTimestamp;
    const dateToView = new Date(timestampToView);
    const firstOfMonthToView = dateToView.setDate(1);
    this.firstOfMonthToViewDayStamp = `${firstOfMonthToView / dayInMilliseconds}`;
    const datesArray = calendarUtils.getCalendarDatesArray(selectedTimestamp, timestampToView, this.isDayUnavailable);

    return (
      <section className="search-unit-custom-control-calendar">
        <div className="search-unit-custom-control-calendar__inner">
          <div className="search-unit-custom-control-calendar__month">
            { !this.isFirstMonth && <a href="#" className="search-unit-custom-control-calendar__month__prev" onClick={this.goToPreviousMonth}><span>Previous month</span></a>}
            <select onChange={this.onMonthChange} value={Math.ceil(this.firstOfMonthToViewDayStamp)}>
              {
                this.monthCollection.map((item, index) => <option value={item.value} key={index}>{item.name}</option>)
              }
            </select>
            { !this.isLastMonth && <a href="#" className="search-unit-custom-control-calendar__month__next" onClick={this.goToNextMonth}><span>Next month</span></a> }
          </div>
          <table className="search-unit-custom-control-calendar__table">
            <thead className="search-unit-custom-control-calendar__table__legend">
              <tr>
                {['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'].map((day, index) =>
                  <th key={index} className="search-unit-custom-control-calendar__table__legend__day">{day}</th>,
                )}
              </tr>
            </thead>
            <tbody className="search-unit-custom-control-calendar__table__page">
              { range(Math.ceil(datesArray.length / 7)).map((val, trIndex) => (
                <tr key={trIndex}>
                  { datesArray.splice(0, 7).map((date, index) => (
                    <SearchUnitCustomControlCalendarDay
                      key={index}
                      date={date}
                      handleDayClick={handleDayClick}
                      appState={appState}
                    />
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          { !hideLegend && (
            <div className="search-unit-custom-control-calendar__key">
              <div className="search-unit-custom-control-calendar__key__dummy-day">17</div>
              <div className="search-unit-custom-control-calendar__key__text">No holidays available for this date</div>
            </div>
          )}
        </div>
      </section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitCustomControlCalendar/SearchUnitCustomControlCalendar.jsx
 **/